import React, { useState, useRef, Component } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, AlertTriangle, Eye, Search, Heart, MessageCircle, UserPlus, ThumbsDown, Target, Camera, Zap, TrendingUp, AlarmClockOff, RefreshCw, XCircle, Sparkles, Clock, MessageSquare, Repeat, BookOpen, ChevronRight, Wand2, Smartphone, Share2, Flame, Lightbulb, Tags, Monitor, Plus, Equal, Anchor, HeartHandshake, AlertCircle, HelpCircle, Gamepad2, Fingerprint, Quote, ArrowRight, PawPrint, Bird, Copy, FileText, Megaphone, Film, Smile, Link2, Ban, CheckCircle2, Rocket, Download, Apple, PlayCircle, Compass, Crown, UserCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
const topics = [{
  id: 'getting-started',
  name: 'Getting Started',
  description: 'Set up Pawchi and your Pawchi Plus access'
}, {
  id: 'account-warmup',
  name: 'Account Warmup',
  description: 'How to set up your TikTok account for success'
}, {
  id: 'viral-formula',
  name: 'The Viral Formula',
  description: 'The 4 organic formats that drive Pawchi growth'
}, {
  id: 'hooks',
  name: 'Hooks & Viral Angles',
  description: 'High-leverage hook patterns + comment bait'
}, {
  id: 'finch-pawchi',
  name: 'Finch → Pawchi Examples',
  description: 'Proven Finch UGC captions, remixed for Pawchi'
}, {
  id: 'ugc-brief',
  name: 'UGC Brief',
  description: 'The complete creative brief template for Pawchi videos'
}];
export function CreatorHelpCenter() {
  const [activeTopic, setActiveTopic] = useState('getting-started');
  const mainRef = useRef<HTMLElement>(null);
  function handleTopicSelect(topicId: string) {
    setActiveTopic(topicId);
    requestAnimationFrame(() => {
      mainRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }
  return <div className="min-h-screen bg-cream" data-id="element-189" data-mp="d8v5tl2668rv">
      <div className="max-w-7xl mx-auto px-6 pt-32 pb-20" data-id="element-190" data-mp="n3aiifqls207">
        <Link to="/creator" className="inline-flex items-center gap-2 text-warmBrown/60 hover:text-peach transition-colors mb-8 font-medium" data-id="element-191" data-mp="n0o7g64i74d8">
          <ArrowLeftIcon size={18} data-id="element-192" data-mp="e0how5ty7e77" />
          Back to Creator Program
        </Link>

        <div className="mb-12 max-w-2xl" data-id="element-193" data-mp="92g9buvqdx0h">
          <div className="inline-flex items-center gap-2 bg-peach/10 text-peach px-3 py-1 rounded-full text-sm font-bold mb-4" data-id="element-194" data-mp="444vl92bf2cz">
            <BookOpen size={14} data-id="element-195" data-mp="3viked63wgazj" />
            Creator Help Center
          </div>
          <h1 className="text-4xl md:text-5xl font-black text-warmBrown mb-4 leading-tight" data-id="element-196" data-mp="3rgz5dvuhkgum">
            Everything you need to{' '}
            <span className="text-peach" data-id="element-197" data-mp="3mj778k38zyhz">create content that converts</span>
          </h1>
          <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-198" data-mp="3hhzvk9xzif61">
            Guides, protocols, and tips to help you grow your audience and earn
            more with Pawchi.
          </p>
        </div>

        <div className="grid md:grid-cols-[260px_1fr] gap-10" data-id="element-199" data-mp="32ezw3mtdvyd1">
          {/* Sidebar */}
          <aside data-id="element-200" data-mp="37ebaip6a2rrg">
            <div className="sticky top-32" data-id="element-201" data-mp="37dtbjks8dzfu">
              <h4 className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-4" data-id="element-202" data-mp="3ce7guv2g6va6">
                Topics
              </h4>
              <nav className="space-y-1" data-id="element-203" data-mp="3hc929mncj6ot">
                {topics.map(topic => <button key={topic.id} onClick={() => handleTopicSelect(topic.id)} className={`w-full text-left px-4 py-3 rounded-xl flex items-center justify-between transition-all ${activeTopic === topic.id ? 'bg-peach text-white shadow-soft' : 'text-warmBrown hover:bg-white'}`} data-id="element-204" data-mp="2jqbbl1ytbv1s">
                    <span className="font-medium" data-id="element-205" data-mp="2yg98c6at5t2l">{topic.name}</span>
                    <ChevronRight size={16} className={activeTopic === topic.id ? 'opacity-100' : 'opacity-30'} data-id="element-206" data-mp="20yit41hdds8b" />
                  </button>)}

                <div className="mt-6 p-4 bg-white rounded-xl border border-warmBrown/5" data-id="element-207" data-mp="6jlj93gvagwo">
                  <p className="text-xs text-warmBrown/60 leading-relaxed" data-id="element-208" data-mp="l7zt3ycpb5mq">
                    More guides coming soon. Have a topic you want covered?{' '}
                    <Link to="/contact-us" className="text-peach font-bold hover:underline" data-id="element-209" data-mp="gex0bsfr007l">
                      Let us know
                    </Link>
                    .
                  </p>
                </div>
              </nav>
            </div>
          </aside>

          {/* Main content */}
          <main ref={mainRef} className="scroll-mt-32" data-id="element-210" data-mp="z8sn8hz3bypb">
            {activeTopic === 'getting-started' && <GettingStartedTopic data-id="element-211" data-mp="35yqk6j65pjyq" />}
            {activeTopic === 'account-warmup' && <AccountWarmupTopic data-id="element-212" data-mp="30ze0266o6qzu" />}
            {activeTopic === 'viral-formula' && <ViralFormulaTopic data-id="element-213" data-mp="1ggtn0ex0e9n6" />}
            {activeTopic === 'hooks' && <HooksTopic data-id="element-214" data-mp="1ghbte4ddy48t" />}
            {activeTopic === 'finch-pawchi' && <FinchPawchiTopic data-id="element-215" data-mp="1lgfzgm50jlux" />}
            {activeTopic === 'ugc-brief' && <UgcBriefTopic data-id="element-216" data-mp="1lhr4epa72znm" />}
          </main>
        </div>
      </div>
    </div>;
}
function GettingStartedTopic() {
  const steps = [{
    number: 1,
    title: 'Download Pawchi',
    icon: <Download size={22} data-id="element-217" data-mp="1bnqpxwt0wi28" />,
    color: 'peach' as const,
    content: <>
          <p className="text-warmBrown/80 leading-relaxed mb-5" data-id="element-218" data-mp="xsez40hznbql">
            Pawchi is available on iOS and Android. Tap the matching badge for
            your phone to install.
          </p>
          <div className="flex flex-col sm:flex-row gap-3" data-id="element-219" data-mp="ntz7lwf1u0gk">
            <motion.a href="https://apps.apple.com/us/app/pawchi-self-care-pet/id6764858701" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-block" data-id="element-220" data-mp="ssaebya1ruuk">
              <img src="https://cdn.magicpatterns.com/uploads/bgW7hVXTEHmConMeGXzro4/app-store.svg" alt="Download on the App Store" className="h-[52px] w-auto" data-id="element-221" data-mp="2gp9wvcoj5804" />
            </motion.a>
            <motion.a href="https://play.google.com/store/apps/details?id=app.pawchi.mobile" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-block -ml-3 sm:ml-0" data-id="element-222" data-mp="27pwji8xabza4">
              <img src="https://cdn.magicpatterns.com/uploads/omQrJZxYBdQEgWZzBHqrye/play-store.png" alt="Get it on Google Play" className="h-[76px] w-auto -my-3" data-id="element-223" data-mp="2qmefx3n2wncp" />
            </motion.a>
          </div>
        </>
  }, {
    number: 2,
    title: 'Create your Pawchi',
    icon: <PawPrint size={22} data-id="element-224" data-mp="19uj30yxgn7ad" />,
    color: 'coral' as const,
    content: <>
          <p className="text-warmBrown/80 leading-relaxed mb-4" data-id="element-225" data-mp="1dwe3y2bhbinm">
            Upload a photo of your pet to transform them into your digital
            Pawchi companion. Pick a clear, well-lit shot for the best
            transformation.
          </p>
          <Callout color="peach" icon={<HeartHandshake size={16} data-id="element-227" data-mp="1stewg81hvhn5" />} title="Don't have a pet?" data-id="element-226" data-mp="1ntsfpomgjj9l">
            No problem! Use any pet photo you love, or{' '}
            <strong data-id="element-228" data-mp="1xkwykzf97o9p">contact us</strong> and we'll assign one for you.
          </Callout>
          <Callout color="lavender" icon={<Sparkles size={16} data-id="element-230" data-mp="26l33vy0sthxs" />} title="Pro tip: make it unique" data-id="element-229" data-mp="21koxslirci2e">
            Add a <strong data-id="element-231" data-mp="2bk63h2y0evyd">funny feature or accessory</strong> to your Pawchi —
            sunglasses, a tiny hat, a chef's apron, anything weird. A
            one-of-a-kind look is what makes viewers stop scrolling and comment.
          </Callout>
        </>
  }, {
    number: 3,
    title: 'Complete onboarding',
    icon: <CheckCircle2 size={22} data-id="element-232" data-mp="1vhysqiexmrna" />,
    color: 'lavender' as const,
    content: <>
          <p className="text-warmBrown/80 leading-relaxed mb-4" data-id="element-233" data-mp="1rfu1fqbyi73t">
            Walk through the onboarding flow inside the app. This sets up your
            habits, mood tracker, and connects everything to your new Pawchi.
          </p>
          <Callout color="coral" icon={<Film size={16} data-id="element-235" data-mp="1cjcqv1blcwib" />} title="Hit record before you start" data-id="element-234" data-mp="yt9c0vf1k52w">
            Screen-record your onboarding so you can{' '}
            <strong data-id="element-236" data-mp="17qtdo5gtg3e1">capture the emotional transformation</strong> from your real
            pet to the digitized Pawchi. That reveal moment is your most viral
            asset — you only get one first reaction, so don't miss it.
          </Callout>
        </>
  }, {
    number: 4,
    title: 'Explore the app',
    icon: <Compass size={22} data-id="element-237" data-mp="angk41piv6ih" />,
    color: 'sage' as const,
    content: <p className="text-warmBrown/80 leading-relaxed" data-id="element-238" data-mp="apjjhcckebzv">
          Tap around. Get comfortable with how habits, the mood log, breathing
          exercises, and your Pawchi's reactions all fit together. The more
          familiar you are, the more genuine your videos will feel.
        </p>
  }, {
    number: 5,
    title: 'Unlock Pawchi Plus',
    icon: <Crown size={22} data-id="element-239" data-mp="tm2l7gl1gxme" />,
    color: 'peach' as const,
    content: <>
          <p className="text-warmBrown/80 leading-relaxed mb-4" data-id="element-240" data-mp="eoijcijfvikg">
            Once you've explored the app,{' '}
            <strong className="text-warmBrown" data-id="element-241" data-mp="jmtuqxpdu14s">let us know</strong> — we'll
            grant you Pawchi Plus, which unlocks all animations and premium
            features so your content can showcase the full experience.
          </p>
          <Callout color="lavender" icon={<Sparkles size={16} data-id="element-243" data-mp="1ijm30kyxcdj8" />} title="Need more Pawchis?" data-id="element-242" data-mp="1iiawide3grof">
            If you want to feature additional pets in your content, contact us
            for <strong data-id="element-244" data-mp="18t122qvs2wx5">extra credits</strong>.
          </Callout>
        </>
  }];
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach',
      solid: 'bg-peach'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral',
      solid: 'bg-coral'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender',
      solid: 'bg-lavender'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage',
      solid: 'bg-sage'
    }
  };
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-245" data-mp="utrntwr4ucvt">
      {/* Intro */}
      <header data-id="element-246" data-mp="2p4dgk4azl16m">
        <div className="inline-flex items-center gap-2 bg-sage/10 text-sage px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-247" data-mp="dj4kscdcw8lj">
          <Rocket size={14} data-id="element-248" data-mp="8lw1u9kdw0j8" />
          Start Here
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-249" data-mp="n9h3dz1m1rp1">
          Getting Started with Pawchi
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-250" data-mp="igwbx466fqoo">
          Welcome to the Pawchi Creator Program! Follow these{' '}
          <strong className="text-warmBrown" data-id="element-251" data-mp="wbqeor4pdp3h">5 quick steps</strong> to get set
          up with the app, unlock Pawchi Plus, and start creating content.
        </p>
      </header>

      {/* What is Pawchi */}
      <section className="bg-gradient-to-br from-peach to-coral rounded-3xl p-8 md:p-10 text-white" data-id="element-252" data-mp="118yvana7dl2m">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-253" data-mp="37zewa7a6aoui">
          <PawPrint size={14} data-id="element-254" data-mp="331wlscgic1ke" />
          What is Pawchi?
        </div>
        <p className="text-xl md:text-2xl font-bold leading-snug mb-3" data-id="element-255" data-mp="16y8ls6pn0990">
          Pawchi turns your real pet into a cute digital companion.
        </p>
        <p className="text-white/90 leading-relaxed" data-id="element-256" data-mp="1by4q6728y2p3">
          Keep them happy by completing daily habits, tracking your mood, and
          taking moments to breathe. Self-care, gamified — and powered by the
          pet you actually love.
        </p>
      </section>

      {/* Steps */}
      <section className="space-y-5" data-id="element-257" data-mp="1ptyo5v1hf7nf">
        {steps.map(step => {
        const c = colorMap[step.color];
        return <article key={step.number} className="bg-white rounded-3xl p-8 shadow-soft border border-warmBrown/5" data-id="element-258" data-mp="1zlcizpihnja8">
              <div className="flex items-start gap-4 mb-5" data-id="element-259" data-mp="23mof8dvvb2re">
                <div className={`w-14 h-14 rounded-2xl ${c.solid} text-white flex items-center justify-center flex-shrink-0 font-black text-xl`} data-id="element-260" data-mp="28nlsqd5xn8mk">
                  {step.number}
                </div>
                <div className="flex-1 min-w-0" data-id="element-261" data-mp="2nqvn92afqms4">
                  <div className="flex items-center gap-2 mb-1" data-id="element-262" data-mp="2ipy5gqtc7ur5">
                    <span className={c.text} data-id="element-263" data-mp="2isu2mcxd2fej">{step.icon}</span>
                    <p className={`text-xs font-bold uppercase tracking-wider ${c.text}`} data-id="element-264" data-mp="2ds65ramgb4ce">
                      Step {step.number}
                    </p>
                  </div>
                  <h3 className="text-2xl font-black text-warmBrown" data-id="element-265" data-mp="36i6a98d1ifeq">
                    {step.title}
                  </h3>
                </div>
              </div>
              <div data-id="element-266" data-mp="2wp7cp0zkfeiz">{step.content}</div>
            </article>;
      })}
      </section>

      {/* Contact us */}
      <section className="bg-warmBrown rounded-3xl p-8 md:p-10 text-cream" data-id="element-267" data-mp="2soezjwnkophf">
        <div className="flex items-start gap-4 mb-4" data-id="element-268" data-mp="3p7l7sstiomed">
          <div className="w-12 h-12 rounded-full bg-peach/20 text-peach flex items-center justify-center flex-shrink-0" data-id="element-269" data-mp="3kfuxgmukxymy">
            <UserCircle2 size={22} data-id="element-270" data-mp="34xacpy90qinl" />
          </div>
          <div data-id="element-271" data-mp="34zwjvwrzyw5a">
            <h3 className="text-2xl font-black mb-1" data-id="element-272" data-mp="35068bfxe8v8v">Need help? Contact us</h3>
            <p className="text-cream/60 text-sm" data-id="element-273" data-mp="39y7qlymzwqja">
              For Pawchi Plus access, extra credits, or anything you get stuck
              on.
            </p>
          </div>
        </div>
        <Link to="/contact-us" className="inline-flex items-center gap-2 px-6 py-3 bg-peach hover:bg-peach/90 text-white rounded-full font-bold transition-colors mt-4" data-id="element-274" data-mp="2zz0h5mjdtg1g">
          Get in touch
          <ArrowRight size={16} data-id="element-275" data-mp="3sp8ris7oew5h" />
        </Link>
      </section>

      {/* Next steps */}
      <Callout color="sage" icon={<Lightbulb size={18} data-id="element-277" data-mp="3ix2x7btyc2n4" />} title="Once you're set up" data-id="element-276" data-mp="3etwxyo59bbq5">
        Jump to <strong data-id="element-278" data-mp="ai1fegoil50k">Account Warmup</strong> next to prep your TikTok or
        Instagram account before posting your first Pawchi video. The warmup is
        the #1 reason new creators see early traction.
      </Callout>
    </motion.article>;
}
function AccountWarmupTopic() {
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-279" data-mp="1zwkazewtoa5q">
      {/* Intro */}
      <header data-id="element-280" data-mp="24qoj41htqo8e">
        <div className="inline-flex items-center gap-2 bg-coral/10 text-coral px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-281" data-mp="24q5874qld03v">
          <AlertTriangle size={14} data-id="element-282" data-mp="1c1himwyt7oki" />
          Non-Negotiable
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-283" data-mp="1c3c5whxjzsrr">
          Account Warmup Protocol
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-284" data-mp="1lym7x5nyc05j">
          Starting a new account without warmup is the{' '}
          <strong className="text-warmBrown" data-id="element-285" data-mp="32cc9o5rlmcc0">
            #1 reason first videos flop
          </strong>
          . TikTok needs behavioral signal before it knows who to show your
          content to.
        </p>
      </header>

      {/* Step 0: Handle Setup */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-286" data-mp="39gbvpmmf71ya">
        <div className="flex items-start gap-4 mb-5" data-id="element-287" data-mp="3efy8juyc6g6k">
          <div className="w-14 h-14 rounded-2xl bg-warmBrown text-cream flex items-center justify-center flex-shrink-0 font-black text-xl" data-id="element-288" data-mp="3eggc7cnbvwoi">
            0
          </div>
          <div className="flex-1 min-w-0" data-id="element-289" data-mp="2ls2e6ww8p0cy">
            <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-1" data-id="element-290" data-mp="2lowq9kzck4it">
              Before You Begin
            </p>
            <h3 className="text-2xl font-black text-warmBrown" data-id="element-291" data-mp="2vonmps7gwtlj">
              Set Up Your Handles
            </h3>
            <p className="text-warmBrown/60 text-sm mt-1" data-id="element-292" data-mp="30gyt9dwprdn2">
              Lock in your TikTok and Instagram handles before posting day 1.
            </p>
          </div>
        </div>

        <div className="space-y-5" data-id="element-293" data-mp="27z3274vo1oa5">
          <div data-id="element-294" data-mp="27y1o0rjcslo7">
            <p className="text-xs font-bold uppercase tracking-wider text-peach mb-2" data-id="element-295" data-mp="27xi2l0uhvf5f">
              Step 1 · Pick a handle
            </p>
            <p className="text-warmBrown/80 leading-relaxed mb-3" data-id="element-296" data-mp="l2dabxfr9qbr">
              Choose the same handle for TikTok and Instagram. We recommend{' '}
              <strong className="text-warmBrown" data-id="element-297" data-mp="g1z0c9ulg6b3">your name + pet name</strong>{' '}
              or something{' '}
              <strong className="text-warmBrown" data-id="element-298" data-mp="b735l1xz34ua">
                wellness / self-care related
              </strong>
              .
            </p>

            <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-2" data-id="element-299" data-mp="1dup1qxvex2c">
              Examples
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-300" data-mp="3tiy8skarh10m">
              {['@miguelandpolo', '@dailypolo', '@dailylifeofatlas', '@atlasselfcare'].map(handle => <span key={handle} className="px-3 py-1.5 bg-peach/10 text-peach rounded-lg font-bold text-sm border border-peach/20" data-id="element-301" data-mp="3elpgnodmvt7u">
                  {handle}
                </span>)}
            </div>
          </div>

          <div data-id="element-302" data-mp="xc1iy3upmmkr">
            <p className="text-xs font-bold uppercase tracking-wider text-peach mb-2" data-id="element-303" data-mp="xckqcqmqhskj">
              Step 2 · Send us your info
            </p>
            <p className="text-warmBrown/80 leading-relaxed mb-3" data-id="element-304" data-mp="129l0bcmpffgx">
              Once you've picked your handle, send us:
            </p>
            <ul className="space-y-2" data-id="element-305" data-mp="scydwjeqcgcs">
              <li className="flex items-start gap-3 text-warmBrown/80" data-id="element-306" data-mp="sdzypfljsh7p">
                <CheckCircle2 size={18} className="text-peach mt-0.5 flex-shrink-0" data-id="element-307" data-mp="em3cfs6k91j8" />
                Your{' '}
                <strong className="text-warmBrown" data-id="element-308" data-mp="jik2irxblpyy">
                  chosen TikTok & Instagram handle
                </strong>
              </li>
              <li className="flex items-start gap-3 text-warmBrown/80" data-id="element-309" data-mp="9mqgmhxpok4i">
                <CheckCircle2 size={18} className="text-peach mt-0.5 flex-shrink-0" data-id="element-310" data-mp="3m62tqt32p8lv" />
                Your{' '}
                <strong className="text-warmBrown" data-id="element-311" data-mp="3i6al6gdoj2gi">
                  personal email address
                </strong>
              </li>
            </ul>
          </div>

          <div data-id="element-312" data-mp="3r44edig5dfzg">
            <p className="text-xs font-bold uppercase tracking-wider text-peach mb-2" data-id="element-313" data-mp="3r3kw20ml4pkw">
              Step 3 · Get your creator email
            </p>
            <p className="text-warmBrown/80 leading-relaxed" data-id="element-314" data-mp="4y7i8vhfz91x">
              We'll send you back a{' '}
              <strong className="text-warmBrown" data-id="element-315" data-mp="ip2tufjbs497">
                dedicated email address
              </strong>{' '}
              to use when signing up on TikTok and Instagram. This keeps your
              creator accounts clean and separate from your personal inbox.
            </p>
          </div>

          <div data-id="element-316" data-mp="nop4qibol8eu">
            <p className="text-xs font-bold uppercase tracking-wider text-peach mb-2" data-id="element-317" data-mp="np8gtienh2ky">
              Step 4 · Sign up and set up your accounts
            </p>
            <p className="text-warmBrown/80 leading-relaxed mb-3" data-id="element-318" data-mp="109062vt9ew3r">
              Use the{' '}
              <strong className="text-warmBrown" data-id="element-319" data-mp="vagg8kbjp064">dedicated email</strong> we
              sent you to create your TikTok and Instagram accounts under your
              chosen handle. Then fill out the profile:
            </p>
            <ul className="space-y-2 mb-4" data-id="element-320" data-mp="hg5zoq9pccb5">
              <li className="flex items-start gap-3 text-warmBrown/80" data-id="element-321" data-mp="hh796qb2kqqr">
                <CheckCircle2 size={18} className="text-peach mt-0.5 flex-shrink-0" data-id="element-322" data-mp="cino0s4avizg" />
                Use a{' '}
                <strong className="text-warmBrown" data-id="element-323" data-mp="liarrkki50vo">
                  genuine, authentic photo of you and your pet
                </strong>{' '}
                as your profile picture
              </li>
              <li className="flex items-start gap-3 text-warmBrown/80" data-id="element-324" data-mp="3pwr0vkw3e13p">
                <CheckCircle2 size={18} className="text-peach mt-0.5 flex-shrink-0" data-id="element-325" data-mp="3puek3b22lws8" />
                Write a short, friendly bio that hints at the self-care + pet
                vibe
              </li>
              <li className="flex items-start gap-3 text-warmBrown/80" data-id="element-326" data-mp="35vfouf9tavos">
                <CheckCircle2 size={18} className="text-peach mt-0.5 flex-shrink-0" data-id="element-327" data-mp="3at7qi109dw66" />
                Keep the same handle, photo, and bio consistent across TikTok
                and Instagram
              </li>
            </ul>
            <Callout color="sage" icon={<Heart size={16} data-id="element-329" data-mp="3ok2rys8fhazq" />} title="Why authentic matters" data-id="element-328" data-mp="7aegfy6ovpgr">
              Real-you-with-real-pet photos build trust instantly. Stock images,
              AI portraits, or pet-only photos look like a brand account — which
              kills the personal-discovery feel that drives conversions.
            </Callout>
          </div>

          <Link to="/contact-us" className="inline-flex items-center gap-2 px-6 py-3 bg-peach hover:bg-peach/90 text-white rounded-full font-bold transition-colors" data-id="element-330" data-mp="olth0yxmi1jy">
            Send your handle
            <ArrowRight size={16} data-id="element-331" data-mp="ev8cyvz6k4tn" />
          </Link>
        </div>
      </section>

      {/* Days 1-2 */}
      <PhaseCard phase="Days 1–2" title="Pure Observer Mode" color="lavender" icon={<Eye size={24} data-id="element-333" data-mp="4znev8x8fop6" />} data-id="element-332" data-mp="9wds7ohnk66w">
        <div className="space-y-4" data-id="element-334" data-mp="4vr8uizktyzs">
          <Rule icon={<XCircle size={18} data-id="element-336" data-mp="vfq5bqry8qy" />} negative data-id="element-335" data-mp="w8vc8a34q6z">
            Do <strong data-id="element-337" data-mp="yv3oa4sv9q9">NOT</strong> post anything
          </Rule>
          <Rule icon={<Clock size={18} data-id="element-339" data-mp="3s31xpfgm6vd3" />} data-id="element-338" data-mp="3s3l7g8w42dg1">
            Open app <strong data-id="element-340" data-mp="3n3ys9twq2n4l">2× per day</strong>, 10 minutes each session
          </Rule>
          <Rule icon={<Search size={18} data-id="element-342" data-mp="1qbezotyb2074" />} data-id="element-341" data-mp="3n61s15nofumi">
            Search your exact niche:{' '}
            <em className="text-warmBrown/70" data-id="element-343" data-mp="1q9cd6jwd2p75">
              "pet care routine," "self-care habits," "tamagotchi," "virtual
              pet," "cat routine," "dog self care"
            </em>
          </Rule>
          <Rule icon={<Eye size={18} data-id="element-345" data-mp="1xuy1sij8qk5k" />} data-id="element-344" data-mp="1su0lyclpe278">
            Watch every video <strong data-id="element-346" data-mp="1xtmz6m1j7ig1">TO THE END</strong> — partial watches are
            negative signals
          </Rule>
          <Rule icon={<Heart size={18} data-id="element-348" data-mp="22mg3j8t38orl" />} data-id="element-347" data-mp="22m6ebnfvalmy">
            Like <strong data-id="element-349" data-mp="27khojza2qy5p">20–30 niche videos</strong> per day
          </Rule>
          <Rule icon={<MessageCircle size={18} data-id="element-351" data-mp="27mlok64urd0p" />} data-id="element-350" data-mp="27mu0nvt5ieau">
            Leave <strong data-id="element-352" data-mp="19y24qqu6doez">5 genuine comments</strong> (full sentences, not
            emojis or one-word replies)
          </Rule>
          <Rule icon={<UserPlus size={18} data-id="element-354" data-mp="1ey6cnsh0patl" />} data-id="element-353" data-mp="1ewc1v6zgmz38">
            Follow <strong data-id="element-355" data-mp="1junaxfhxl5ke">3–5 relevant accounts</strong>
          </Rule>
          <Rule icon={<ThumbsDown size={18} data-id="element-357" data-mp="1ou9q3uhbkvvu" />} data-id="element-356" data-mp="1jxjaf89fg2ay">
            Aggressively tap <strong data-id="element-358" data-mp="1ovujhgrwe8s4">"Not Interested"</strong> on anything
            off-niche
          </Rule>
        </div>

        <Callout color="sage" icon={<Target size={18} data-id="element-360" data-mp="2vcoh0ncoikzu" />} title="Goal by Day 2" data-id="element-359" data-mp="2va274h2bfteg">
          Your For You Page shows pet content, self-care content, habit apps,
          and cute animal transformations. If it doesn't,{' '}
          <strong data-id="element-361" data-mp="2xwl17p6ud0j5">you moved too fast</strong>.
        </Callout>
      </PhaseCard>

      {/* Engagement Mix */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-362" data-mp="37sxvao6atgef">
        <div className="flex items-start gap-4 mb-6" data-id="element-363" data-mp="32tup30el144v">
          <div className="w-12 h-12 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-364" data-mp="32s9u59ocvj6h">
            <Target size={22} data-id="element-365" data-mp="3grj8e3t0437t" />
          </div>
          <div data-id="element-366" data-mp="3cstxqizckzrv">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-367" data-mp="3cr93kugy3iuj">
              Your Engagement Mix
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-368" data-mp="3qinnd3iofo2n">
              The exact ratio of content to watch, like, and comment on during
              warmup.
            </p>
          </div>
        </div>

        <div className="space-y-4" data-id="element-369" data-mp="4cgxqizpwruo">
          <EngagementBucket percent={30} label="Pets" color="peach" items={['Funny dog videos', 'Pet POV content', 'Pet-owner relatable content', 'Cute animal clips', 'Pet transformations']} goal="Tell TikTok you're interested in pet owners." data-id="element-370" data-mp="3vis5exz8gquz" />
          <EngagementBucket percent={30} label="Plushies & Stuffed Animals" color="coral" items={['Plushie collecting', 'Stuffed animal care', 'Plushie adventures', 'Comfort items', 'Cozy and nostalgic toy content']} goal="Reach people drawn to the comfort, care, security, and nostalgia of a beloved companion." data-id="element-371" data-mp="dzkx4732cqmr" />
          <EngagementBucket percent={20} label="Self-Care" color="lavender" items={['Water intake', 'Morning routines', 'Habit tracking', 'Self-improvement', 'Wellness content']} goal="Tell TikTok you're interested in people actively trying to improve themselves." data-id="element-372" data-mp="3rcn02ypkssav" />
          <EngagementBucket percent={20} label="Productivity / Mental Health" color="sage" items={['Atomic Habits', 'Motivation', 'Journaling', 'ADHD productivity', '"Get your life together" content']} goal="Reach the audience that actually installs apps." data-id="element-373" data-mp="2om51tw3amd5e" />
        </div>
      </section>

      {/* Day 3 */}
      <PhaseCard phase="Day 3" title="Diagnostic Posting" color="peach" icon={<Camera size={24} data-id="element-375" data-mp="32da5d99s7pl0" />} data-id="element-374" data-mp="37as3s5q6amer">
        <p className="text-warmBrown/80 leading-relaxed mb-4" data-id="element-376" data-mp="1vx7v8q8g24sh">
          Before posting real content, post <strong data-id="element-377" data-mp="1qymtgmdjnd1x">2 slideshows</strong> (low
          production effort). These are diagnostic tools.
        </p>

        <div className="bg-cream/60 rounded-2xl p-6 mb-4" data-id="element-378" data-mp="6gudkad4p1hn">
          <p className="font-bold text-warmBrown mb-3" data-id="element-379" data-mp="6e9d9pshatm0">
            A slideshow "passed" if within 5 hours it gets:
          </p>
          <ul className="space-y-2" data-id="element-380" data-mp="gerz2q3lsk6k">
            <li className="flex items-center gap-3 text-warmBrown/80" data-id="element-381" data-mp="gdqhe2s30zfv">
              <span className="w-2 h-2 rounded-full bg-peach" data-id="element-382" data-mp="l5i7kc7bt35h"></span>
              <strong className="text-warmBrown" data-id="element-383" data-mp="q4bmm929h27r">500+</strong> impressions
            </li>
            <li className="flex items-center gap-3 text-warmBrown/80" data-id="element-384" data-mp="q6o0ob4wesfj">
              <span className="w-2 h-2 rounded-full bg-peach" data-id="element-385" data-mp="u4c0nslg7bea"></span>
              <strong className="text-warmBrown" data-id="element-386" data-mp="z4qang6m0vey">20–30+</strong> likes
            </li>
          </ul>
        </div>

        <div className="grid sm:grid-cols-2 gap-3" data-id="element-387" data-mp="142rrrvkh6kns">
          <div className="bg-sage/10 border border-sage/20 rounded-xl p-4" data-id="element-388" data-mp="30wctgugclk0c">
            <p className="text-sm font-bold text-sage mb-1" data-id="element-389" data-mp="30yh6q304zvda">✓ If it passes</p>
            <p className="text-sm text-warmBrown/80" data-id="element-390" data-mp="35vzh7xtsyine">
              Post up to 3 main videos that same day.
            </p>
          </div>
          <div className="bg-coral/10 border border-coral/20 rounded-xl p-4" data-id="element-391" data-mp="16oiq9svelu27">
            <p className="text-sm font-bold text-coral mb-1" data-id="element-392" data-mp="16mg2lfhq4d0n">✗ If it fails</p>
            <p className="text-sm text-warmBrown/80" data-id="element-393" data-mp="1lcvokwhyrozv">
              Do one more day of observer mode. Your account is still cold.
            </p>
          </div>
        </div>
      </PhaseCard>

      {/* Day 4+ */}
      <PhaseCard phase="Day 4+" title="Active Posting" color="sage" icon={<Zap size={24} data-id="element-395" data-mp="nrhhdwyqb9sz" />} data-id="element-394" data-mp="sozt1v44s34o">
        <div className="space-y-4" data-id="element-396" data-mp="12mxe69qp1jt2">
          <Rule icon={<Camera size={18} data-id="element-398" data-mp="12np5h8d9cvdj" />} data-id="element-397" data-mp="12nyqsincyecw">
            Post <strong data-id="element-399" data-mp="12kkthotjwvcb">1–2 videos per day</strong>
          </Rule>
          <Rule icon={<Repeat size={18} data-id="element-401" data-mp="xmj8uzgh8nyq" />} data-id="element-400" data-mp="xm9hb7fsa8qx">
            Continue the daily feed engagement routine (10 min, 2×/day) —{' '}
            <strong data-id="element-402" data-mp="2e46wgsy365ss">this is not optional</strong>
          </Rule>
          <Rule icon={<TrendingUp size={18} data-id="element-404" data-mp="292hknb31ho3n" />} data-id="element-403" data-mp="2927w7rxn7p02">
            Watch performance and adjust format based on what's holding viewers
          </Rule>
        </div>
      </PhaseCard>

      {/* Abandonment Rule */}
      <section className="bg-warmBrown rounded-3xl p-8 md:p-10 text-cream" data-id="element-405" data-mp="2ln6gn0tdg1d7">
        <div className="flex items-start gap-4 mb-4" data-id="element-406" data-mp="27mvqy13ssstm">
          <div className="w-12 h-12 rounded-full bg-coral/20 text-coral flex items-center justify-center flex-shrink-0" data-id="element-407" data-mp="27o6qfoq7neex">
            <AlarmClockOff size={22} data-id="element-408" data-mp="2zci1u1fvx54z" />
          </div>
          <div data-id="element-409" data-mp="2zds12tyh4jd7">
            <h3 className="text-2xl font-black mb-1" data-id="element-410" data-mp="2zfcnfwamwvzz">
              Account Abandonment Rule
            </h3>
            <p className="text-cream/60 text-sm" data-id="element-411" data-mp="2qkog80li148j">
              When to cut your losses and restart.
            </p>
          </div>
        </div>

        <div className="space-y-4 text-cream/80 leading-relaxed" data-id="element-412" data-mp="2ukyxwainlj38">
          <p data-id="element-413" data-mp="3ibcgzbj9g7lo">
            If <strong className="text-cream" data-id="element-414" data-mp="3ibmb9bbc90x6">6 consecutive videos</strong> stay
            under 300 views: post 3 videos recorded natively inside TikTok (no
            external edits, no CapCut). Sometimes this resets the trust signal.
          </p>
          <p data-id="element-415" data-mp="sc44ryfmg4rj">
            If still nothing after those 3 videos:{' '}
            <strong className="text-cream" data-id="element-416" data-mp="we8yex62l1e6">abandon the account</strong>. Restart
            costs 2 days. Staying on a dead account costs weeks.
          </p>
        </div>
      </section>

      {/* Retention Benchmark */}
      <section className="bg-gradient-to-br from-peach to-coral rounded-3xl p-8 md:p-10 text-white" data-id="element-417" data-mp="167prfyyducgs">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-418" data-mp="9hfi4rvqmh16">
          <TrendingUp size={14} data-id="element-419" data-mp="iezgnt27tz83" />
          Most Important Metric
        </div>
        <h3 className="text-3xl font-black mb-4" data-id="element-420" data-mp="nfn9mka08q4y">The Retention Benchmark</h3>
        <p className="text-white/90 leading-relaxed mb-6" data-id="element-421" data-mp="1tv6a09vuisuj">
          TikTok distributes in waves. A video gets shown to a small test batch.
          If they watch to the end, it gets shown to a bigger batch.{' '}
          <strong className="text-white" data-id="element-422" data-mp="3jcusqht82pss">This compounds.</strong>
        </p>

        <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-6 mb-6 border border-white/20" data-id="element-423" data-mp="3je600rlvmfon">
          <p className="text-sm uppercase tracking-wider text-white/70 font-bold mb-2" data-id="element-424" data-mp="39mibaygpfcqv">
            Target
          </p>
          <p className="text-4xl md:text-5xl font-black mb-2" data-id="element-425" data-mp="34nyn0ren1ovc">42%+</p>
          <p className="text-white/90" data-id="element-426" data-mp="34lktimzlwkpw">full video completion rate</p>
          <p className="text-sm text-white/70 mt-3" data-id="element-427" data-mp="30nerttdmkvbu">
            Below 42%, distribution waves stop. Above it, they compound.
          </p>
        </div>

        <h4 className="font-bold mb-3 text-white" data-id="element-428" data-mp="2qne7c440s962">Practical implications:</h4>
        <ul className="space-y-3 mb-6" data-id="element-429" data-mp="2qph2f2k14shn">
          <li className="flex items-start gap-3 text-white/90" data-id="element-430" data-mp="2lpcif2jwxfmo">
            <span className="font-black text-white" data-id="element-431" data-mp="owaqgx3jdyd2">1.</span>
            <span data-id="element-432" data-mp="ovrb9o59to2q">
              First <strong className="text-white" data-id="element-433" data-mp="otwxquwbwy8o">3 seconds must hook</strong>{' '}
              (stop the scroll)
            </span>
          </li>
          <li className="flex items-start gap-3 text-white/90" data-id="element-434" data-mp="2ed4vkq3ml074">
            <span className="font-black text-white" data-id="element-435" data-mp="2j44t9xkkjmao">2.</span>
            <span data-id="element-436" data-mp="2j5pnfm2z1380">
              Middle must move{' '}
              <strong className="text-white" data-id="element-437" data-mp="24fqtjvig8dyc">fast enough</strong> that dropping
              off feels like a loss
            </span>
          </li>
          <li className="flex items-start gap-3 text-white/90" data-id="element-438" data-mp="29elast0rpugc">
            <span className="font-black text-white" data-id="element-439" data-mp="2x3mp2wwa7ztj">3.</span>
            <span data-id="element-440" data-mp="2x2344szol0lf">
              Last <strong className="text-white" data-id="element-441" data-mp="323irirpbzj6z">3 seconds must earn</strong>{' '}
              the watch (payoff or pattern interrupt)
            </span>
          </li>
        </ul>

        <p className="text-white/90 leading-relaxed mb-4" data-id="element-442" data-mp="2s4ta101ck0r9">
          Slow middles kill videos that have great hooks.{' '}
          <strong className="text-white" data-id="element-443" data-mp="1cnjcwv2y11jy">Cut ruthlessly.</strong>
        </p>
        <p className="text-white/80 text-sm leading-relaxed" data-id="element-444" data-mp="1gpo3tm20bk2w">
          Likes and comments matter, but only as downstream effects of
          retention. Retention is the root signal.
        </p>

        <div className="mt-6 pt-6 border-t border-white/20" data-id="element-445" data-mp="14729xeq3qqef">
          <p className="text-sm uppercase tracking-wider text-white/70 font-bold mb-2" data-id="element-446" data-mp="146iovp55nlw6">
            3-Second Watch-Time Benchmark
          </p>
          <p className="text-white/90 leading-relaxed" data-id="element-447" data-mp="1e587jk4vladh">
            <strong className="text-white" data-id="element-448" data-mp="1e5rgibcjsofd">75–80%</strong> of viewers watching
            past the first 3 seconds = "viral-ready" format. Use this as the
            primary filter for what formats to scale.
          </p>
        </div>
      </section>

      {/* Daily Maintenance */}
      <PhaseCard phase="Daily" title="Maintenance (Forever)" color="lavender" icon={<Repeat size={24} data-id="element-450" data-mp="vd5pq5ghzo1n" />} data-id="element-449" data-mp="1068m0lcntblj">
        <p className="text-warmBrown/80 leading-relaxed" data-id="element-451" data-mp="vcw0ik3a1kx0">
          Warming up is not a one-time event. If you stop behaving like a human
          on the app (watching, liking, commenting), the account goes cold and
          performance drops.{' '}
          <strong className="text-warmBrown" data-id="element-452" data-mp="325dbzctempgv">
            Treat daily feed engagement like brushing teeth.
          </strong>
        </p>
      </PhaseCard>

      {/* Comment Seeding */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-453" data-mp="3b4idms09iyx9">
        <div className="flex items-start gap-4 mb-6" data-id="element-454" data-mp="3fvqntq9f2obh">
          <div className="w-12 h-12 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-455" data-mp="3fxbh7cjzw17r">
            <MessageSquare size={22} data-id="element-456" data-mp="3pteiyhaxpxu6" />
          </div>
          <div data-id="element-457" data-mp="3prtm2l15e2t5">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-458" data-mp="3pvhgdmef2t8x">
              Comment Seeding
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-459" data-mp="2oyoa42pq0nh">
              Turning curiosity into conversions.
            </p>
          </div>
        </div>

        <p className="text-warmBrown/80 leading-relaxed mb-6" data-id="element-460" data-mp="1ziigricsaiat">
          When a video gains traction but isn't converting, the issue is often a{' '}
          <strong className="text-warmBrown" data-id="element-461" data-mp="1wwspx180diji">
            lack of visible social proof
          </strong>{' '}
          in comments. Seed comments from secondary accounts.
        </p>

        <h4 className="font-bold text-warmBrown mb-3" data-id="element-462" data-mp="1s4981s2ag18w">
          Effective seed comments:
        </h4>
        <div className="space-y-2 mb-6" data-id="element-463" data-mp="1n4n09y58bd7h">
          {['what app is this??', 'does this actually work?', 'omg I need to try this with my cat', 'my dog would literally be perfect for this', 'anyone used this consistently? results?'].map(comment => <div key={comment} className="bg-cream/60 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 border-peach/40" data-id="element-464" data-mp="25wxtf0a2zwse">
              "{comment}"
            </div>)}
        </div>

        <Callout color="sage" icon={<Sparkles size={18} data-id="element-466" data-mp="ufz7lhi5hljw" />} title="Pro tip" data-id="element-465" data-mp="ujve08jpxd9t">
          Give Claude the hook of the video + your ICP + Pawchi description →
          generate an organic-sounding comment where the persona explains how
          the app helped them. This turns passive viewers into curious readers
          who then convert.
        </Callout>

        <p className="text-warmBrown font-bold mt-6 text-center" data-id="element-467" data-mp="i07vsv1se0lo">
          No comments = no curiosity = no conversions.
        </p>
      </section>
    </motion.article>;
}
function ViralFormulaTopic() {
  const ingredients = [{
    label: 'Viral Feature',
    title: 'Real pet photo → animated AI sprite',
    desc: 'A "reveal moment" — identical in structure to face ratings, food scanners, or body analysis apps that generate millions of views. The reveal IS the ad.',
    icon: <Wand2 size={22} data-id="element-468" data-mp="481olygm33yd" />,
    color: 'peach' as const
  }, {
    label: 'Core Desire',
    title: 'Love + identity + nostalgia',
    desc: 'Love for a real pet, desire for a self-care identity, and Tamagotchi nostalgia — three of the strongest emotional pulls online right now.',
    icon: <Heart size={22} data-id="element-469" data-mp="37qphgx5zkvue" />,
    color: 'coral' as const
  }, {
    label: 'Shareable Output',
    title: 'The animated pet sprite',
    desc: "The animated pet sprite, the pet's 'stats,' and the transformation itself — all inherently shareable across stories, group chats, and feeds.",
    icon: <Share2 size={22} data-id="element-470" data-mp="3bsb254orief5" />,
    color: 'lavender' as const
  }];
  const formats = [{
    number: 1,
    priority: 'Highest Priority',
    title: 'The Transformation Reveal',
    structure: 'Real pet photo (before) → dramatic transition → animated Pawchi sprite (after)',
    hooks: ['"I turned my cat into a Tamagotchi... [she has opinions]"', '"POV you upload your dog\'s photo to this app"', '"This AI turned my actual cat into an animated version of herself and I\'m not okay"'],
    why: 'The reveal creates genuine delight and "I want to see mine" impulse. The comment section fills with "do mine!" requests organically. Highest-conversion format.',
    icon: <Wand2 size={22} data-id="element-471" data-mp="1fnrqy02z4x36" />,
    color: 'peach' as const
  }, {
    number: 2,
    priority: 'Self-Care Angle',
    title: 'The Accountability Loop',
    structure: 'Morning routine or habit check-in, showing how completing habits makes the pet thrive',
    hooks: ['"My virtual pet died because I didn\'t drink water [I deserved it]"', '"Day 14 of letting my pet motivate my self-care routine"', '"What happens to your Pawchi when you skip your habits for 3 days"'],
    why: 'Demonstrates the core gameplay loop and the emotional stakes (pet declining hits hard). Creates relatability for anyone who struggles with habits.',
    icon: <Heart size={22} data-id="element-472" data-mp="1aqi14jboajet" />,
    color: 'coral' as const
  }, {
    number: 3,
    priority: 'Pet Identity',
    title: 'Slideshows',
    structure: '"If you\'re the kind of person who [trait]... your pet would be a [species/type]" — or — "What your self-care score says about your pet\'s personality"',
    hooks: [],
    why: 'Identity labeling creates instant engagement. People tag friends, share to stories, comment with their own results.',
    icon: <Tags size={22} data-id="element-473" data-mp="qxfeuprwgb9" />,
    color: 'lavender' as const
  }, {
    number: 4,
    priority: 'App Demo',
    title: 'Screen Recording Demo',
    structure: 'Screen record of onboarding / pet customization with voiceover or text captions',
    hooks: ['"Okay this app genuinely got me to drink water for the first time in a week"'],
    why: "Shows the product in the most authentic, low-production way. Feels user-generated even when it isn't.",
    icon: <Monitor size={22} data-id="element-474" data-mp="397s8xjkokoco" />,
    color: 'sage' as const
  }];
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach',
      solid: 'bg-peach'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral',
      solid: 'bg-coral'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender',
      solid: 'bg-lavender'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage',
      solid: 'bg-sage'
    }
  };
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-475" data-mp="n7tz7ix001ln">
      {/* Intro */}
      <header data-id="element-476" data-mp="1fw7ye1ztp3ys">
        <div className="inline-flex items-center gap-2 bg-peach/10 text-peach px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-477" data-mp="1fuws9viwnk4i">
          <Flame size={14} data-id="element-478" data-mp="16v9udjpdwwg7" />
          Growth Strategy
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-479" data-mp="11xi0wl93d29w">
          The Viral Formula for Pawchi
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-480" data-mp="3rnlc3j21a9ks">
          Every viral product on TikTok and Reels follows the same recipe.{' '}
          <strong className="text-warmBrown" data-id="element-481" data-mp="3mptm4uky8xj8">
            Pawchi has all three ingredients.
          </strong>{' '}
          Here's how to use them.
        </p>
      </header>

      {/* Formula equation */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-482" data-mp="27258ioiuu5tp">
        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-6" data-id="element-483" data-mp="2fwt9i2hed1cp">
          The Formula
        </p>
        <div className="flex flex-wrap items-center gap-3 md:gap-4 text-warmBrown" data-id="element-484" data-mp="2kwfoohgscro5">
          <span className="px-4 py-2 bg-peach/10 text-peach rounded-xl font-bold text-sm md:text-base" data-id="element-485" data-mp="2puqwynrfmu49">
            Viral Feature
          </span>
          <Plus size={18} className="text-warmBrown/40" data-id="element-486" data-mp="2uveulsa6297g" />
          <span className="px-4 py-2 bg-coral/10 text-coral rounded-xl font-bold text-sm md:text-base" data-id="element-487" data-mp="2yvfehsg1bclw">
            Core Human Desire
          </span>
          <Plus size={18} className="text-warmBrown/40" data-id="element-488" data-mp="10hvt67d0m6gv" />
          <span className="px-4 py-2 bg-lavender/10 text-lavender rounded-xl font-bold text-sm md:text-base" data-id="element-489" data-mp="14h4ovhrm8ef2">
            Shareable Output
          </span>
          <Equal size={18} className="text-warmBrown/40" data-id="element-490" data-mp="27uo7pgkbkvt1" />
          <span className="px-4 py-2 bg-warmBrown text-cream rounded-xl font-bold text-sm md:text-base" data-id="element-491" data-mp="22uikqdozvxha">
            Organic Growth Machine
          </span>
        </div>
      </section>

      {/* Three ingredients */}
      <section data-id="element-492" data-mp="2cq3iu0qy0dlr">
        <h3 className="text-2xl font-black text-warmBrown mb-6" data-id="element-493" data-mp="2ctrbkxokcvzf">
          How Pawchi checks every box
        </h3>
        <div className="grid md:grid-cols-3 gap-4" data-id="element-494" data-mp="2lscqmiuttsvg">
          {ingredients.map(item => {
          const c = colorMap[item.color];
          return <div key={item.label} className="bg-white rounded-3xl p-6 shadow-soft border border-warmBrown/5 flex flex-col" data-id="element-495" data-mp="30gpoxmhdznt4">
                <div className={`w-12 h-12 rounded-full ${c.bg} ${c.text} flex items-center justify-center mb-4`} data-id="element-496" data-mp="39h5ssx21kwyi">
                  {item.icon}
                </div>
                <p className={`text-xs font-bold uppercase tracking-wider ${c.text} mb-1`} data-id="element-497" data-mp="3o4cppyuozuee">
                  {item.label}
                </p>
                <h4 className="font-black text-warmBrown mb-2 leading-tight" data-id="element-498" data-mp="3f47uen2rwmgl">
                  {item.title}
                </h4>
                <p className="text-sm text-warmBrown/70 leading-relaxed" data-id="element-499" data-mp="3j4hytvax34tc">
                  {item.desc}
                </p>
              </div>;
        })}
        </div>
      </section>

      {/* Reveal mechanic */}
      <section className="bg-gradient-to-br from-peach to-coral rounded-3xl p-8 md:p-10 text-white" data-id="element-500" data-mp="3a663jfz3viuk">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-501" data-mp="2vhrz50m1jmbw">
          <Sparkles size={14} data-id="element-502" data-mp="2mgbr2zip7wau" />
          Highest Priority
        </div>
        <h3 className="text-3xl font-black mb-4" data-id="element-503" data-mp="2re3vgt0j5avx">The Reveal Mechanic</h3>
        <p className="text-white/90 leading-relaxed mb-6" data-id="element-504" data-mp="2rgg6snbs8n00">
          The single most viral moment in Pawchi is the transformation: user
          uploads real pet photo → Pawchi generates animated sprite. This is
          your{' '}
          <strong className="text-white" data-id="element-505" data-mp="29ncm1oc4gujj">UMax "face rating reveal,"</strong>{' '}
          your <strong className="text-white" data-id="element-506" data-mp="25m9avf50rmon">Cal AI "calorie reveal."</strong>
        </p>
        <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-6 border border-white/20 mb-6" data-id="element-507" data-mp="25kg9ae99jsni">
          <p className="font-bold text-lg leading-snug" data-id="element-508" data-mp="20ktnvhja763m">
            Every ad creative, every organic video, every influencer brief must
            center on this reveal.{' '}
            <span className="block mt-2" data-id="element-509" data-mp="1qpa2vq699rtn">
              Do not show features. Show the reveal.
            </span>
          </p>
        </div>
        <div data-id="element-510" data-mp="3l2rhuoslhgd2">
          <p className="text-sm uppercase tracking-wider text-white/70 font-bold mb-2" data-id="element-511" data-mp="3l3b0y8tzeaso">
            Why it works
          </p>
          <p className="text-white/90 leading-relaxed" data-id="element-512" data-mp="3h1xupxmz85l8">
            TikTok and Reels are dopamine delivery systems. The reveal gives
            viewers a reason to watch to the end, and a reason to comment{' '}
            <em className="text-white" data-id="element-513" data-mp="17qx6pymalsic">("omg do mine," "what is this app")</em>.
            Both behaviors drive algorithmic distribution.
          </p>
        </div>
      </section>

      {/* Four formats intro */}
      <section data-id="element-514" data-mp="1gn67bgm0ax62">
        <h3 className="text-2xl md:text-3xl font-black text-warmBrown mb-2" data-id="element-515" data-mp="jusucmpada39">
          The Four Organic Formats
        </h3>
        <p className="text-warmBrown/70 leading-relaxed mb-8" data-id="element-516" data-mp="ot42mszxncjd">
          Ranked by priority. Mix and match these for your weekly content
          schedule.
        </p>

        <div className="space-y-5" data-id="element-517" data-mp="xukel56ebmpp">
          {formats.map(format => {
          const c = colorMap[format.color];
          return <article key={format.number} className="bg-white rounded-3xl p-8 shadow-soft border border-warmBrown/5" data-id="element-518" data-mp="249mg8li0k4gr">
                <div className="flex items-start gap-4 mb-5" data-id="element-519" data-mp="977u0sjk4ben">
                  <div className={`w-14 h-14 rounded-2xl ${c.solid} text-white flex items-center justify-center flex-shrink-0 font-black text-xl`} data-id="element-520" data-mp="99kk5szgxs2s">
                    {format.number}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-521" data-mp="e62j2c84aw77">
                    <p className={`text-xs font-bold uppercase tracking-wider ${c.text} mb-1`} data-id="element-522" data-mp="e4hq2r1gblbg">
                      Format {format.number} · {format.priority}
                    </p>
                    <h4 className="text-xl md:text-2xl font-black text-warmBrown" data-id="element-523" data-mp="6jefteim2zn">
                      {format.title}
                    </h4>
                  </div>
                </div>

                <div className="mb-5" data-id="element-524" data-mp="33vwiorgrhyvx">
                  <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-2" data-id="element-525" data-mp="33uutzk6tpdvq">
                    Structure
                  </p>
                  <p className="text-warmBrown/80 leading-relaxed" data-id="element-526" data-mp="2yuyyyag3swsb">
                    {format.structure}
                  </p>
                </div>

                {format.hooks.length > 0 && <div className="mb-5" data-id="element-527" data-mp="1j7c004ikxeze">
                    <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-3" data-id="element-528" data-mp="15evsorinauso">
                      Hook options
                    </p>
                    <div className="space-y-2" data-id="element-529" data-mp="1x58wz20y3nel">
                      {format.hooks.map(hook => <div key={hook} className={`bg-cream/60 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 ${c.text.replace('text-', 'border-')}/40`} data-id="element-530" data-mp="224d2nionv306">
                          {hook}
                        </div>)}
                    </div>
                  </div>}

                <div className={`${c.bg} rounded-2xl p-5`} data-id="element-531" data-mp="hoi79jukfu72">
                  <div className="flex items-center gap-2 mb-2" data-id="element-532" data-mp="hq32zcsm9j6i">
                    <Lightbulb size={16} className={c.text} data-id="element-533" data-mp="18etvn8oyz4lm" />
                    <p className={`font-bold text-sm ${c.text}`} data-id="element-534" data-mp="18c8rgd178ckp">
                      Why it works
                    </p>
                  </div>
                  <p className="text-warmBrown/80 text-sm leading-relaxed" data-id="element-535" data-mp="zeyfsqkgylf9">
                    {format.why}
                  </p>
                </div>
              </article>;
        })}
        </div>
      </section>
    </motion.article>;
}
function HooksTopic() {
  const categories = [{
    label: 'Emotional / Attachment',
    icon: <HeartHandshake size={22} data-id="element-536" data-mp="1n5u4vfxjj2it" />,
    color: 'coral' as const,
    hooks: ['"I cried when I saw my cat as an animated character [she has her exact markings]"', '"This app turned my dead dog into a living animated version of him [I\'m not okay]"', '"POV: your actual pet becomes your virtual self-care companion"']
  }, {
    label: 'Accountability / Consequence',
    icon: <AlertCircle size={22} data-id="element-537" data-mp="2ddqhdm4nxgit" />,
    color: 'peach' as const,
    hooks: ['"My virtual pet literally got sick because I didn\'t sleep enough [I deserved it]"', '"The only thing that made me actually do my morning routine is not wanting to let my cat down"', '"What happens to your Pawchi when you skip days [warning: sad]"']
  }, {
    label: 'Curiosity / Transformation',
    icon: <HelpCircle size={22} data-id="element-538" data-mp="2wd4ay2yhcp8s" />,
    color: 'lavender' as const,
    hooks: ['"Watch me turn my dog into a Tamagotchi [AI did this in 10 seconds]"', '"I uploaded my cat\'s photo and now I have to take care of her digitally"', '"This app is literally Tamagotchi but your actual pet [how is this free]"']
  }, {
    label: 'Nostalgia',
    icon: <Gamepad2 size={22} data-id="element-539" data-mp="3g0vb5ske9366" />,
    color: 'sage' as const,
    hooks: ['"Tamagotchi but it\'s YOUR actual pet and it\'s connected to your real habits"', '"Grew up with Tamagotchis, now I have one but it looks exactly like my dog"', '"POV: it\'s 2006 and your Tamagotchi is your actual cat"']
  }, {
    label: 'Identity',
    icon: <Fingerprint size={22} data-id="element-540" data-mp="vif2xkh9jemd" />,
    color: 'peach' as const,
    hooks: ['"Self-care apps never worked for me until my cat\'s wellbeing depended on it"', '"I\'m a terrible habit person but I\'ve been consistent for 30 days because of this app"', '"Turns out the only accountability system I needed was a virtual version of my own pet"']
  }];
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach',
      border: 'border-peach/40'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral',
      border: 'border-coral/40'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender',
      border: 'border-lavender/40'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage',
      border: 'border-sage/40'
    }
  };
  const commentBait = ['Flash a leaderboard showing a rival pet beating the user\'s pet (provokes "how do you compete?" comments)', 'Show a strange/unexpected pet name or stat combination', 'Show the pet\'s "disapproval" animation', 'Anything that makes viewers feel they saw something and need to comment about it'];
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-541" data-mp="3mkz6w9rd9w8a">
      {/* Intro */}
      <header data-id="element-542" data-mp="37u8f31pryx56">
        <div className="inline-flex items-center gap-2 bg-peach/10 text-peach px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-543" data-mp="37v1aj6jaa080">
          <Anchor size={14} data-id="element-544" data-mp="n3r5fg3athn9" />
          Hook Library
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-545" data-mp="n26cfuwmu6ri">
          Hooks &amp; Viral Angles
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-546" data-mp="j4i9q5op79p2">
          The first 3 seconds decide everything. Swipe these{' '}
          <strong className="text-warmBrown" data-id="element-547" data-mp="3gv7iwya903yq">
            highest-leverage hook angles
          </strong>{' '}
          for Pawchi, then customize them with details about your specific pet.
        </p>
      </header>

      {/* Hook categories */}
      <section className="space-y-5" data-id="element-548" data-mp="3pvm7q7mf816z">
        {categories.map(cat => {
        const c = colorMap[cat.color];
        return <article key={cat.label} className="bg-white rounded-3xl p-8 shadow-soft border border-warmBrown/5" data-id="element-549" data-mp="2y4zmt04yuds1">
              <div className="flex items-center gap-4 mb-5" data-id="element-550" data-mp="325jjy3pjhhe6">
                <div className={`w-12 h-12 rounded-full ${c.bg} ${c.text} flex items-center justify-center flex-shrink-0`} data-id="element-551" data-mp="36xt4f47vxp92">
                  {cat.icon}
                </div>
                <h3 className="text-xl md:text-2xl font-black text-warmBrown" data-id="element-552" data-mp="2eg72kgk2630s">
                  {cat.label} Hooks
                </h3>
              </div>

              <div className="space-y-2" data-id="element-553" data-mp="21ymth5ez1a78">
                {cat.hooks.map(hook => <div key={hook} className={`bg-cream/60 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 ${c.border}`} data-id="element-554" data-mp="21wtl9lopmhx4">
                    {hook}
                  </div>)}
              </div>
            </article>;
      })}
      </section>

      {/* Hook structure formula */}
      <section className="bg-gradient-to-br from-peach to-coral rounded-3xl p-8 md:p-10 text-white" data-id="element-555" data-mp="1j6lodlblsnpd">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-556" data-mp="1e9leezbmv0sz">
          <Sparkles size={14} data-id="element-557" data-mp="158x0s5q5j2gm" />
          The Formula
        </div>
        <h3 className="text-3xl font-black mb-4" data-id="element-558" data-mp="15a8464foq877">Hook Structure Formula</h3>
        <p className="text-white/90 leading-relaxed mb-6" data-id="element-559" data-mp="10a2kpbjkjs07">
          For Pawchi specifically, the highest-performing hook pattern is:
        </p>

        <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-8" data-id="element-560" data-mp="35b4yu0zwi96n">
          <span className="px-4 py-2 bg-white/20 backdrop-blur-sm rounded-xl font-bold text-sm md:text-base border border-white/30" data-id="element-561" data-mp="35cg1fxhm1aw6">
            Specific personal detail
          </span>
          <Plus size={18} className="text-white/60" data-id="element-562" data-mp="2viqt6x5pcif7" />
          <span className="px-4 py-2 bg-white/20 backdrop-blur-sm rounded-xl font-bold text-sm md:text-base border border-white/30" data-id="element-563" data-mp="2hksqwq4nocg2">
            Surprising outcome
          </span>
          <Plus size={18} className="text-white/60" data-id="element-564" data-mp="27need1lus7t1" />
          <span className="px-4 py-2 bg-white/20 backdrop-blur-sm rounded-xl font-bold text-sm md:text-base border border-white/30" data-id="element-565" data-mp="27opgkwznh7i1">
            Implicit challenge / FOMO
          </span>
        </div>

        <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-6 border border-white/20" data-id="element-566" data-mp="5wb4wfnp8za2">
          <p className="text-sm uppercase tracking-wider text-white/70 font-bold mb-3" data-id="element-567" data-mp="attco2pzd8gh">
            Example
          </p>
          <p className="text-white/95 leading-relaxed italic" data-id="element-568" data-mp="1vaaqqkgigmca">
            "I uploaded my{' '}
            <strong className="text-white not-italic bg-white/20 px-1.5 py-0.5 rounded" data-id="element-569" data-mp="1qbpnec5ypmjm">
              grey tabby's photo
            </strong>{' '}
            [specific] and she now has{' '}
            <strong className="text-white not-italic bg-white/20 px-1.5 py-0.5 rounded" data-id="element-570" data-mp="209ncf1vnbnda">
              her exact markings in the app
            </strong>{' '}
            [surprising] and{' '}
            <strong className="text-white not-italic bg-white/20 px-1.5 py-0.5 rounded" data-id="element-571" data-mp="2964n6403lj8i">
              my water intake has never been higher
            </strong>{' '}
            [FOMO/outcome]"
          </p>
        </div>
      </section>

      {/* Comment bait */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-572" data-mp="tob6kdwebnl2">
        <div className="flex items-start gap-4 mb-5" data-id="element-573" data-mp="op8ahiye8rp8">
          <div className="w-12 h-12 rounded-full bg-lavender/10 text-lavender flex items-center justify-center flex-shrink-0" data-id="element-574" data-mp="1ecc6dnlgad9o">
            <MessageSquare size={22} data-id="element-575" data-mp="1id5twfuzdq21" />
          </div>
          <div data-id="element-576" data-mp="1ig0gacxk1ky3">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-577" data-mp="1nd0keiaugdmk">
              Comment Bait Elements
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-578" data-mp="1scmzkxa8g3y0">
              Hide something that provokes a reaction.
            </p>
          </div>
        </div>

        <p className="text-warmBrown/80 leading-relaxed mb-6" data-id="element-579" data-mp="1x93v4cjrhkl4">
          Hide something in the video that provokes comments. It{' '}
          <strong className="text-warmBrown" data-id="element-580" data-mp="263rxnuxyco68">
            does not need to be related to the app
          </strong>
          :
        </p>

        <ul className="space-y-3 mb-6" data-id="element-581" data-mp="2b23b0fnghgt7">
          {commentBait.map(item => <li key={item} className="flex items-start gap-3" data-id="element-582" data-mp="2g2r18z3v1tmd">
              <span className="mt-2 w-2 h-2 rounded-full bg-lavender flex-shrink-0" data-id="element-583" data-mp="2l0slhnd0vyzf"></span>
              <span className="text-warmBrown/80 leading-relaxed" data-id="element-584" data-mp="9dfkna5rc1ch">{item}</span>
            </li>)}
        </ul>

        <div className="bg-warmBrown rounded-2xl p-5 text-cream" data-id="element-585" data-mp="4dt7t1tucn47">
          <p className="font-bold text-center text-lg" data-id="element-586" data-mp="4gfbgqdm2ih5">
            Comments → engagement → cheaper CPM on ads → more distribution.
          </p>
        </div>
      </section>
    </motion.article>;
}
function FinchPawchiTopic() {
  const pairs = [{
    finch: 'Nobody: That one person who remembers to drink water because a bird on her phone told her to',
    pawchi: 'Nobody: That one person drinking water because a pixel version of her dog is judging her',
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7618231189844806926'
  }, {
    finch: 'Me trying to drink water so I can get more rainbow stones on Finch',
    pawchi: 'Me chugging water because I turned my dog into a Tamagotchi',
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7644182635153001742'
  }, {
    finch: 'Making my stupid bed so my Finch can get back from her stupid adventure',
    pawchi: 'Making my stupid bed because my dog somehow lives in my phone now',
    referenceUrl: 'https://www.tiktok.com/@madiebooth/video/7474039283083529503'
  }, {
    finch: 'Rotting in bed? Not anymore thanks to this cute self care app',
    pawchi: "Rotting in bed? My dog won't let me anymore",
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7457035886274907438'
  }, {
    finch: 'POV: your sink is overflowing with dishes and the only motivation to wash them is because of a silly little bird on your phone',
    pawchi: "POV: the only reason these dishes are getting done is because my dog gets sad when I don't",
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7642362206276881678'
  }, {
    finch: 'Me trying to act nonchalant but I literally have a bird on my phone reminding me to drink water',
    pawchi: 'Me trying to explain why a digital version of my dog controls my life',
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7644182635153001742'
  }, {
    finch: 'Download a silly little self care app not expecting it to work',
    pawchi: 'Downloaded an app that turned my dog into a virtual pet. Somehow my life is together now',
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7263861893255761194'
  }, {
    finch: 'I love being a girl in 2026 because someone made a Studio Ghibli self care app',
    pawchi: 'I love being alive in 2026 because I can turn my dog into a Tamagotchi',
    referenceUrl: 'https://www.tiktok.com/@reb.ponyo/video/7627477323406642445'
  }, {
    finch: 'POV: this silly goofy bird on your phone is the reason why you remember to treat yourself',
    pawchi: "POV: my dog has absolutely no idea he's responsible for my mental health now",
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7619002656144575758'
  }, {
    finch: "Checks my birb to see if she's done with her adventure",
    pawchi: 'Checking if my dog survived the day after I forgot to drink water',
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7129210768452521259'
  }];
  const bonusReferences = [{
    caption: 'Me, stressy, depressy and unmotivated',
    url: 'https://www.tiktok.com/@finchcare/video/7068061545644707118',
    handle: '@finchcare'
  }, {
    caption: 'Me: last year, "I wish I was healthier"',
    url: 'https://www.tiktok.com/@tylerandgerald/video/7314567467391700270',
    handle: '@tylerandgerald'
  }, {
    caption: 'Making my stupid bed',
    url: 'https://www.tiktok.com/@finchcare/video/7213858957826329899',
    handle: '@finchcare'
  }];
  function getHandle(url: string) {
    const match = url.match(/@([^/]+)/);
    return match ? `@${match[1]}` : '';
  }
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-587" data-mp="25c91wl3u6a86">
      {/* Intro */}
      <header data-id="element-588" data-mp="1vk3bhft8g0v3">
        <div className="inline-flex items-center gap-2 bg-lavender/10 text-lavender px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-589" data-mp="1vjtl3r49zrov">
          <Copy size={14} data-id="element-590" data-mp="1mm9k8jabrxes" />
          Swipe File
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-591" data-mp="17oqv3ftqji6t">
          Finch → Pawchi Examples
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-592" data-mp="1cod75lxtuse1">
          Finch's UGC playbook is already proven. We've remixed{' '}
          <strong className="text-warmBrown" data-id="element-593" data-mp="3205l7xqnrjn3">
            {pairs.length} of their top-performing caption styles
          </strong>{' '}
          for Pawchi. Use them as templates — swap in your pet's details and
          post.
        </p>
      </header>

      {/* Legend */}
      <div className="grid sm:grid-cols-2 gap-3" data-id="element-594" data-mp="30ji0vaxx3ta8">
        <div className="bg-white rounded-2xl p-4 border border-warmBrown/10 flex items-center gap-3" data-id="element-595" data-mp="2vlq9ci16q96k">
          <div className="w-10 h-10 rounded-full bg-warmBrown/10 text-warmBrown/60 flex items-center justify-center flex-shrink-0" data-id="element-596" data-mp="2rko9byzg1t3j">
            <Bird size={20} data-id="element-597" data-mp="3o9ccjp6i3bsw" />
          </div>
          <div data-id="element-598" data-mp="3oci1n4f4qdom">
            <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40" data-id="element-599" data-mp="3jbuewuxxoj07">
              Original
            </p>
            <p className="font-bold text-warmBrown text-sm" data-id="element-600" data-mp="3ejstaievlfxi">Finch caption</p>
          </div>
        </div>
        <div className="bg-white rounded-2xl p-4 border border-peach/30 flex items-center gap-3" data-id="element-601" data-mp="3ai7hz1hzp9pf">
          <div className="w-10 h-10 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-602" data-mp="awsppeq62j3m">
            <PawPrint size={20} data-id="element-603" data-mp="63ra14i4yfiz" />
          </div>
          <div data-id="element-604" data-mp="1osbz47jvaw64">
            <p className="text-xs font-bold uppercase tracking-wider text-peach" data-id="element-605" data-mp="1osu53vwc0or8">
              Remixed
            </p>
            <p className="font-bold text-warmBrown text-sm" data-id="element-606" data-mp="1trf63xjercgq">Pawchi variant</p>
          </div>
        </div>
      </div>

      {/* Comparison pairs */}
      <section className="space-y-5" data-id="element-607" data-mp="22rboxij49h3v">
        {pairs.map((pair, index) => <article key={index} className="bg-white rounded-3xl p-6 md:p-8 shadow-soft border border-warmBrown/5" data-id="element-608" data-mp="22p7aw7ri71pv" data-mpi={index}>
            <div className="flex items-center gap-3 mb-5" data-id="element-609" data-mp="2coptajrrmfft">
              <span className="w-8 h-8 rounded-full bg-warmBrown text-cream flex items-center justify-center font-black text-sm" data-id="element-610" data-mp="2hgg74zpwvlbz">
                {index + 1}
              </span>
              <span className="text-xs font-bold uppercase tracking-wider text-warmBrown/40" data-id="element-611" data-mp="2lk5slgbahmss">
                Caption Pair
              </span>
            </div>

            <div className="grid md:grid-cols-[1fr_auto_1fr] gap-4 md:gap-5 items-stretch" data-id="element-612" data-mp="2vhahvp0flydt">
              {/* Finch side */}
              <div className="bg-cream/60 rounded-2xl p-5 border border-warmBrown/10" data-id="element-613" data-mp="2hrpbgilcfa0x">
                <div className="flex items-center gap-2 mb-3" data-id="element-614" data-mp="2ctw4vog4oe04">
                  <Bird size={16} className="text-warmBrown/40" data-id="element-615" data-mp="2rjuzjh8h57au" />
                  <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40" data-id="element-616" data-mp="2rl62jeu3ib0w">
                    Finch
                  </p>
                </div>
                <p className="text-warmBrown/80 italic leading-relaxed" data-id="element-617" data-mp="1yvfr5djuln8h">
                  "{pair.finch}"
                </p>
              </div>

              {/* Arrow */}
              <div className="flex md:flex-col items-center justify-center text-peach md:py-4" data-id="element-618" data-mp="28t3u2qrly11q">
                <ArrowRight size={24} className="md:hidden" data-id="element-619" data-mp="23thhmjjlsotz" />
                <ArrowRight size={24} className="hidden md:block" data-id="element-620" data-mp="23w3n8dmxou9k" />
              </div>

              {/* Pawchi side */}
              <div className="bg-peach/10 rounded-2xl p-5 border border-peach/30" data-id="element-621" data-mp="3f962n5dards5">
                <div className="flex items-center justify-between gap-2 mb-3" data-id="element-622" data-mp="3msf2o7zwy04j">
                  <div className="flex items-center gap-2" data-id="element-623" data-mp="3mui4rqecbjpm">
                    <PawPrint size={16} className="text-peach" data-id="element-624" data-mp="3rsjj5y0tmuur" />
                    <p className="text-xs font-bold uppercase tracking-wider text-peach" data-id="element-625" data-mp="3ds0f11zh88xv">
                      Pawchi
                    </p>
                  </div>
                  {pair.referenceUrl && <a href={pair.referenceUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-xs font-bold text-peach hover:text-coral transition-colors" data-id="element-626" data-mp="9d0nzky8kkbt">
                      <Film size={12} data-id="element-627" data-mp="4m0rggt1449u" />
                      <span data-id="element-628" data-mp="4kzg0b83pfrl">{getHandle(pair.referenceUrl)}</span>
                    </a>}
                </div>
                <p className="text-warmBrown leading-relaxed font-medium" data-id="element-629" data-mp="x33bdnr7h243">
                  "{pair.pawchi}"
                </p>
              </div>
            </div>
          </article>)}
      </section>

      {/* Pawchi-original captions */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-630" data-mp="12ytez21mvzyl">
        <div className="flex items-start gap-4 mb-6" data-id="element-631" data-mp="xx40fcf7d45r">
          <div className="w-12 h-12 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-632" data-mp="szatgh62s64f">
            <PawPrint size={22} data-id="element-633" data-mp="o0hgcpupah4s" />
          </div>
          <div data-id="element-634" data-mp="o2c2u8lmehaz">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-635" data-mp="j9iyvmxz7czy">
              More Pawchi-Original Captions
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-636" data-mp="f74gf3y7yf97">
              Original ideas built around the chase-and-transform moment — no
              Finch counterpart.
            </p>
          </div>
        </div>

        <div className="space-y-3" data-id="element-637" data-mp="58omyubpytwj">
          {["POV: me chasing my dog around the house because apparently turning him into a Tamagotchi is the only way I'll start taking care of myself.", "I turned my dog into a Tamagotchi and now he's somehow managing my life better than I am.", 'Was trying to make a digital version of my dog. Accidentally ended up in a healthier lifestyle.', "Me: can't stick to a habit tracker for more than 3 days.\nAlso me: chasing my dog so I can turn him into a Tamagotchi and finally get my life together."].map((caption, idx) => <div key={idx} className="bg-peach/10 rounded-2xl p-5 border border-peach/30" data-id="element-638" data-mp="33n5ytx4gek9y" data-mpi={idx}>
              <div className="flex items-center gap-2 mb-2" data-id="element-639" data-mp="3djskup8inhdk">
                <span className="w-6 h-6 rounded-full bg-peach text-white flex items-center justify-center font-black text-xs flex-shrink-0" data-id="element-640" data-mp="3di7sn69ocaiv">
                  {idx + 1}
                </span>
                <p className="text-xs font-bold uppercase tracking-wider text-peach" data-id="element-641" data-mp="2kubt7tsq04ie">
                  Pawchi
                </p>
              </div>
              <p className="text-warmBrown leading-relaxed font-medium whitespace-pre-line" data-id="element-642" data-mp="7v0nlwy8n882">
                "{caption}"
              </p>
            </div>)}
        </div>
      </section>

      {/* Bonus references */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-643" data-mp="htq4pnib8on9">
        <div className="flex items-start gap-4 mb-6" data-id="element-644" data-mp="ctbxg7oj9iqa">
          <div className="w-12 h-12 rounded-full bg-lavender/10 text-lavender flex items-center justify-center flex-shrink-0" data-id="element-645" data-mp="cwq07h13zty9">
            <Film size={22} data-id="element-646" data-mp="mt2v2i8e4dul" />
          </div>
          <div data-id="element-647" data-mp="msavyxfl3xzk">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-648" data-mp="mqgjm7idpe73">
              Bonus Reference Videos
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-649" data-mp="vl4r84bff7z2">
              Extra TikToks in the Finch / self-care UGC style worth studying.
            </p>
          </div>
        </div>

        <div className="space-y-3" data-id="element-650" data-mp="1afre5794yccs">
          {bonusReferences.map((ref, idx) => <a key={idx} href={ref.url} target="_blank" rel="noopener noreferrer" className="group flex items-center justify-between gap-4 p-4 bg-cream/60 hover:bg-peach/10 rounded-xl border border-warmBrown/5 hover:border-peach/30 transition-all" data-id="element-651" data-mp="15kvizy8lr8vg" data-mpi={idx}>
              <div className="flex items-center gap-3 min-w-0" data-id="element-652" data-mp="1k5hjiqjq4ikz">
                <div className="w-9 h-9 rounded-lg bg-white text-peach flex items-center justify-center flex-shrink-0 shadow-soft" data-id="element-653" data-mp="1k3wshawmbhrv">
                  <Film size={16} data-id="element-654" data-mp="1a7bkcgpaxqjt" />
                </div>
                <div className="min-w-0" data-id="element-655" data-mp="1a8v0m7ayk1ll">
                  <p className="font-medium text-warmBrown italic truncate" data-id="element-656" data-mp="wgf65uw4hbwa">
                    "{ref.caption}"
                  </p>
                  <p className="text-xs text-warmBrown/50 font-bold" data-id="element-657" data-mp="11g1im244mo41">
                    {ref.handle}
                  </p>
                </div>
              </div>
              <ArrowRight size={18} className="text-warmBrown/30 group-hover:text-peach group-hover:translate-x-1 transition-all flex-shrink-0" data-id="element-658" data-mp="rgsrdh0nbnld" />
            </a>)}
        </div>
      </section>

      {/* Closing tip */}
      <Callout color="lavender" icon={<Lightbulb size={18} data-id="element-660" data-mp="x9rht0c753le" />} title="How to use this swipe file" data-id="element-659" data-mp="sdkl7y5ox4g4">
        Don't copy-paste verbatim. Pick a caption that fits your video, then{' '}
        <strong data-id="element-661" data-mp="16biljzn6f0cm">swap in specific details about your pet</strong> — breed, name,
        a unique quirk. The more specific, the higher the engagement.
      </Callout>
    </motion.article>;
}
function UgcBriefTopic() {
  const briefComponents = [{
    icon: <Anchor size={18} data-id="element-662" data-mp="1g1u1ylo1r20e" />,
    label: 'The hook',
    desc: 'Exact words and delivery style to open with'
  }, {
    icon: <Wand2 size={18} data-id="element-663" data-mp="1l27zvavxovkp" />,
    label: 'The transformation demo',
    desc: 'Exactly how to show pet upload → animated result'
  }, {
    icon: <Heart size={18} data-id="element-664" data-mp="1u24tlqx6kkmm" />,
    label: 'The self-care loop',
    desc: 'How to connect habits to pet health in the demo'
  }, {
    icon: <Smile size={18} data-id="element-665" data-mp="3egrigi5epk8j" />,
    label: 'The emotional beat',
    desc: 'The moment of genuine delight or surprise to capture'
  }, {
    icon: <Link2 size={18} data-id="element-666" data-mp="35jh6svooft33" />,
    label: 'The CTA',
    desc: '"Comment your pet and I\'ll show you" / link in bio / App Store'
  }];
  const hooks = ['"I accidentally found the cutest way to stay consistent with my habits."', '"My dog is now judging my self-care."', '"This app turned my pet into a little Tamagotchi."', '"I uploaded a photo of my pet and wasn\'t expecting this."'];
  const transformationSteps = ['Show the real pet first.', 'Capture a cute moment of the pet looking at the camera.', 'Open Pawchi and upload a photo of the pet.', 'Record the transformation process.', 'Reveal the generated Pawchi companion.', 'Spend a few seconds showing the resemblance between the real pet and the digital version.', 'Encourage creators to react genuinely to the result.'];
  const selfCareSteps = ['Briefly explain or demonstrate that completing habits affects the pet.', 'Show one or two habit completions such as drinking water, taking a walk, journaling, or checking in.', 'Return to the app and show the pet reacting positively.', 'The focus should be on the emotional connection, not on explaining features.'];
  const ctas = ['"If you have a pet, you need to try this."', '"Upload your pet and see what it becomes."', '"Link in bio if you want your own Pawchi."', '"Comment your pet and I\'ll show you what it would look like."'];
  const donts = ['Do not mention pricing.', 'Do not mention subscriptions.', 'Do not show paywalls.', 'Do not say "download now".', 'Do not make it sound like a traditional ad.', 'Do not over-explain features.', 'Do not use corporate language.'];
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-667" data-mp="25le7ppge7txm">
      {/* Intro */}
      <header data-id="element-668" data-mp="3p6pzi5qz8nv">
        <div className="inline-flex items-center gap-2 bg-sage/10 text-sage px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-669" data-mp="3owwhklhujdf">
          <FileText size={14} data-id="element-670" data-mp="3v1huq4fpy1wf" />
          Creative Brief
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-671" data-mp="dl9q6ih1gx86">
          UGC Brief Template
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-672" data-mp="8puffzebvhfz">
          The full creative brief for Pawchi videos. Use this as your shot list
          — every video should hit{' '}
          <strong className="text-warmBrown" data-id="element-673" data-mp="hoy2fegm8gzr">all five components</strong> and
          avoid the don'ts.
        </p>
      </header>

      {/* Goal */}
      <section className="bg-gradient-to-br from-peach to-coral rounded-3xl p-8 md:p-10 text-white" data-id="element-674" data-mp="2jgb29p3q7yoy">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-675" data-mp="2luzf6dtirmpv">
          <Target size={14} data-id="element-676" data-mp="2py4fqau1hebv" />
          The Goal
        </div>
        <p className="text-xl md:text-2xl font-bold leading-snug" data-id="element-677" data-mp="2uw60r1b0znpz">
          Show how a real pet can be turned into a digital companion that
          motivates self-care.
        </p>
        <p className="text-white/90 leading-relaxed mt-4" data-id="element-678" data-mp="2278i2x2wjowp">
          The video should feel like a{' '}
          <strong className="text-white" data-id="element-679" data-mp="274s9kyom1y6l">personal discovery</strong>, not a
          sponsored promotion.
        </p>
      </section>

      {/* Brief components overview */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-680" data-mp="2gv3b6ektnvab">
        <h3 className="text-2xl font-black text-warmBrown mb-2" data-id="element-681" data-mp="1jg8xs96cr39r">
          Every brief includes 5 components
        </h3>
        <p className="text-warmBrown/60 text-sm mb-6" data-id="element-682" data-mp="1oeafoqs1kwjn">
          Hit all five — in this order — for a complete video.
        </p>

        <div className="space-y-3" data-id="element-683" data-mp="1gv1915ax7bya">
          {briefComponents.map((item, index) => <div key={item.label} className="flex items-center gap-4 p-4 bg-cream/60 rounded-xl" data-id="element-684" data-mp="1bxrkdrvcv4bi" data-mpi={index}>
              <span className="w-8 h-8 rounded-full bg-peach text-white flex items-center justify-center font-black text-sm flex-shrink-0" data-id="element-685" data-mp="16z6h1jkt44iu">
                {index + 1}
              </span>
              <div className="text-peach flex-shrink-0" data-id="element-686" data-mp="xyrtseoa8fcp">{item.icon}</div>
              <div className="flex-1 min-w-0" data-id="element-687" data-mp="t4dy0b5pk67i">
                <p className="font-bold text-warmBrown" data-id="element-688" data-mp="o6m6vjcw0o4d">{item.label}</p>
                <p className="text-sm text-warmBrown/60" data-id="element-689" data-mp="o4rlk3xpetzr">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </section>

      {/* Step 1: Hook */}
      <BriefStep number={1} title="Hook" subtitle="Open within the first 1–2 seconds." color="peach" icon={<Anchor size={22} data-id="element-691" data-mp="3vrd9n29a9cjk" />} data-id="element-690" data-mp="e86dtauav4s8">
        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-3" data-id="element-692" data-mp="3vqbykxs9oq1u">
          Choose one
        </p>
        <div className="space-y-2 mb-5" data-id="element-693" data-mp="4mn9ddh6kqyj">
          {hooks.map(hook => <div key={hook} className="bg-cream/60 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 border-peach/40" data-id="element-694" data-mp="3mrqkpfxqpz7e">
              {hook}
            </div>)}
        </div>
        <Callout color="peach" icon={<Megaphone size={16} data-id="element-696" data-mp="nbk4tkobdpic" />} title="Delivery" data-id="element-695" data-mp="jarueo3phekh">
          Should feel natural, slightly surprised, and conversational.
        </Callout>
      </BriefStep>

      {/* Step 2: Transformation Demo */}
      <BriefStep number={2} title="Transformation Demo" subtitle="The reveal is the hero of the video." color="coral" icon={<Film size={22} data-id="element-698" data-mp="1279kl12wp6em" />} data-id="element-697" data-mp="ej9t1yxrtbyz">
        <ol className="space-y-3" data-id="element-699" data-mp="126zvdfpor39z">
          {transformationSteps.map((step, idx) => <li key={step} className="flex items-start gap-3" data-id="element-700" data-mp="171nfz3hkjdja" data-mpi={idx}>
              <span className="mt-0.5 w-6 h-6 rounded-full bg-coral/15 text-coral flex items-center justify-center font-black text-xs flex-shrink-0" data-id="element-701" data-mp="1gd1q1zz9f8qm">
                {idx + 1}
              </span>
              <span className="text-warmBrown/80 leading-relaxed" data-id="element-702" data-mp="1q2ur471s05gm">{step}</span>
            </li>)}
        </ol>
      </BriefStep>

      {/* Step 3: Self-Care Loop */}
      <BriefStep number={3} title="Self-Care Loop" subtitle="Connect habits to pet wellbeing." color="lavender" icon={<Heart size={22} data-id="element-704" data-mp="tfq64czxr7vo" />} data-id="element-703" data-mp="xeywr8zoipn0">
        <ol className="space-y-3 mb-5" data-id="element-705" data-mp="17deqzku06f0q">
          {selfCareSteps.map((step, idx) => <li key={step} className="flex items-start gap-3" data-id="element-706" data-mp="12eladjjf67wc" data-mpi={idx}>
              <span className="mt-0.5 w-6 h-6 rounded-full bg-lavender/15 text-lavender flex items-center justify-center font-black text-xs flex-shrink-0" data-id="element-707" data-mp="12da5thi5gw46">
                {idx + 1}
              </span>
              <span className="text-warmBrown/80 leading-relaxed" data-id="element-708" data-mp="2dtidtygcozn8">{step}</span>
            </li>)}
        </ol>
      </BriefStep>

      {/* Step 4: Emotional Beat */}
      <BriefStep number={4} title="Emotional Beat" subtitle="The single most important moment in the video." color="sage" icon={<Smile size={22} data-id="element-710" data-mp="pvpndfr6aqxy" />} data-id="element-709" data-mp="g6zdlhpw5yoe">
        <p className="text-warmBrown/80 leading-relaxed mb-4" data-id="element-711" data-mp="px0yy1qv12zm">
          Capture the moment where the creator realizes:
        </p>
        <div className="bg-sage/10 border-l-4 border-sage/50 rounded-xl px-5 py-4 text-warmBrown/90 italic leading-relaxed mb-5" data-id="element-712" data-mp="ux6n37xx87cy">
          "Wait… now I actually want to complete my habits because I don't want
          my pet to be sad."
        </div>
        <Callout color="sage" icon={<Sparkles size={16} data-id="element-714" data-mp="18sr4fyy04hi9" />} title="What to capture" data-id="element-713" data-mp="18v3m0azukpus">
          The creator should <strong data-id="element-715" data-mp="35p84uodjq9kb">smile, laugh, or react naturally</strong>{' '}
          to the pet's response. This is the moment that converts viewers.
        </Callout>
      </BriefStep>

      {/* Step 5: CTA */}
      <BriefStep number={5} title="CTA" subtitle="End on an invitation, not a sales pitch." color="peach" icon={<Link2 size={22} data-id="element-717" data-mp="2tcconjlk517d" />} data-id="element-716" data-mp="334s8ynkbu1vf">
        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-3" data-id="element-718" data-mp="2tdffjrivr3na">
          Choose one
        </p>
        <div className="space-y-2" data-id="element-719" data-mp="2obq7mkqyf63f">
          {ctas.map(cta => <div key={cta} className="bg-cream/60 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 border-peach/40" data-id="element-720" data-mp="3m11jx1zxmcb7">
              {cta}
            </div>)}
        </div>
      </BriefStep>

      {/* DO NOT section */}
      <section className="bg-warmBrown rounded-3xl p-8 md:p-10 text-cream" data-id="element-721" data-mp="382jzbd5bpfxi">
        <div className="flex items-start gap-4 mb-6" data-id="element-722" data-mp="20nyujexlap13">
          <div className="w-12 h-12 rounded-full bg-coral/20 text-coral flex items-center justify-center flex-shrink-0" data-id="element-723" data-mp="20pjnx18641xd">
            <Ban size={22} data-id="element-724" data-mp="1wozplubuys9n" />
          </div>
          <div data-id="element-725" data-mp="3l2jqbjhlnbgh">
            <h3 className="text-2xl font-black mb-1" data-id="element-726" data-mp="3l0yulqjjtmh1">DO NOT</h3>
            <p className="text-cream/60 text-sm" data-id="element-727" data-mp="3g2nita9p11w6">
              These will sink the video. Avoid every one.
            </p>
          </div>
        </div>

        <ul className="space-y-3" data-id="element-728" data-mp="3bamce4z7i5e2">
          {donts.map(item => <li key={item} className="flex items-start gap-3" data-id="element-729" data-mp="36ccazcmw28k0">
              <XCircle size={18} className="text-coral mt-0.5 flex-shrink-0" data-id="element-730" data-mp="31e15fe3mmk7l" />
              <span className="text-cream/85 leading-relaxed" data-id="element-731" data-mp="31by5a18rfap5">{item}</span>
            </li>)}
        </ul>
      </section>

      {/* Closing mantra */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5 text-center" data-id="element-732" data-mp="2see2uoz5v8cy">
        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-4" data-id="element-733" data-mp="2ng2smd4yevu7">
          Think
        </p>
        <p className="text-2xl md:text-3xl font-black text-warmBrown leading-tight" data-id="element-734" data-mp="qk59r3b5dq5n">
          Personal discovery. Emotional reaction. Cute pet moment. Self-care
          motivation.
        </p>
      </section>
    </motion.article>;
}
interface BriefStepProps {
  number: number;
  title: string;
  subtitle: string;
  color: 'peach' | 'coral' | 'lavender' | 'sage';
  icon: React.ReactNode;
  children: React.ReactNode;
}
function BriefStep({
  number,
  title,
  subtitle,
  color,
  icon,
  children
}: BriefStepProps) {
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach',
      solid: 'bg-peach'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral',
      solid: 'bg-coral'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender',
      solid: 'bg-lavender'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage',
      solid: 'bg-sage'
    }
  };
  const c = colorMap[color];
  return <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-735" data-mp="1vkmpn598tj06">
      <div className="flex items-start gap-4 mb-6" data-id="element-736" data-mp="20io8bp2rbgb4">
        <div className={`w-14 h-14 rounded-2xl ${c.solid} text-white flex items-center justify-center flex-shrink-0 font-black text-xl`} data-id="element-737" data-mp="hq3a4l06rkv">
          {number}
        </div>
        <div className="flex-1 min-w-0" data-id="element-738" data-mp="9iobkz2h5l99">
          <div className="flex items-center gap-2 mb-1" data-id="element-739" data-mp="9hd5gslk41ez">
            <span className={c.text} data-id="element-740" data-mp="5hcfcap3i1s3">{icon}</span>
            <p className={`text-xs font-bold uppercase tracking-wider ${c.text}`} data-id="element-741" data-mp="5hkte5wyfd4v">
              Step {number}
            </p>
          </div>
          <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-742" data-mp="38ykugmsfunj4">{title}</h3>
          <p className="text-warmBrown/60 text-sm" data-id="element-743" data-mp="3moy2ep5by28g">{subtitle}</p>
        </div>
      </div>
      <div data-id="element-744" data-mp="3hyhpd65f8imm">{children}</div>
    </section>;
}
interface EngagementBucketProps {
  percent: number;
  label: string;
  color: 'peach' | 'coral' | 'lavender' | 'sage';
  items: string[];
  goal: string;
}
function EngagementBucket({
  percent,
  label,
  color,
  items,
  goal
}: EngagementBucketProps) {
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach',
      solid: 'bg-peach',
      dot: 'bg-peach'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral',
      solid: 'bg-coral',
      dot: 'bg-coral'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender',
      solid: 'bg-lavender',
      dot: 'bg-lavender'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage',
      solid: 'bg-sage',
      dot: 'bg-sage'
    }
  };
  const c = colorMap[color];
  return <div className="bg-cream/60 rounded-2xl p-5 md:p-6" data-id="element-745" data-mp="33rms7x3x89tn">
      <div className="flex items-center gap-4 mb-4" data-id="element-746" data-mp="2ovxe0l4z90zh">
        <div className={`${c.solid} text-white font-black text-lg md:text-xl rounded-2xl px-4 py-2 flex-shrink-0`} data-id="element-747" data-mp="2ov5g33nwqr61">
          {percent}%
        </div>
        <h4 className="font-black text-warmBrown text-lg md:text-xl" data-id="element-748" data-mp="1dg8obm0c9nuz">
          {label}
        </h4>
      </div>

      {/* Visual percentage bar */}
      <div className="h-1.5 bg-warmBrown/5 rounded-full overflow-hidden mb-5" data-id="element-749" data-mp="1idicyzfwlvhr">
        <div className={`h-full ${c.solid} rounded-full`} style={{
        width: `${percent}%`
      }} data-id="element-750" data-mp="1yoaob1kbhu7a" />
      </div>

      <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2 mb-5" data-id="element-751" data-mp="1owes5w1ske5p">
        {items.map(item => <li key={item} className="flex items-center gap-2 text-warmBrown/80 text-sm" data-id="element-752" data-mp="1jyd7x7smq8sn">
            <span className={`w-1.5 h-1.5 rounded-full ${c.dot} flex-shrink-0`} data-id="element-753" data-mp="2hkk907pq5j09"></span>
            {item}
          </li>)}
      </ul>

      <div className={`${c.bg} rounded-xl px-4 py-3`} data-id="element-754" data-mp="27n5wukau3gdr">
        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-1" data-id="element-755" data-mp="27ll2auoirxfw">
          Goal
        </p>
        <p className={`text-sm font-bold ${c.text}`} data-id="element-756" data-mp="22qp7jmrwevz3">{goal}</p>
      </div>
    </div>;
}
interface PhaseCardProps {
  phase: string;
  title: string;
  color: 'peach' | 'coral' | 'lavender' | 'sage';
  icon: React.ReactNode;
  children: React.ReactNode;
}
function PhaseCard({
  phase,
  title,
  color,
  icon,
  children
}: PhaseCardProps) {
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage'
    }
  };
  const c = colorMap[color];
  return <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-757" data-mp="3mk8veadvgiul">
      <div className="flex items-start gap-4 mb-6" data-id="element-758" data-mp="3qkam5oi2jrv3">
        <div className={`w-12 h-12 rounded-full ${c.bg} ${c.text} flex items-center justify-center flex-shrink-0`} data-id="element-759" data-mp="3vkorgysacnpf">
          {icon}
        </div>
        <div data-id="element-760" data-mp="4cjci8af8v3i">
          <p className={`text-xs font-bold uppercase tracking-wider ${c.text} mb-1`} data-id="element-761" data-mp="217fg11g6is4j">
            {phase}
          </p>
          <h3 className="text-2xl font-black text-warmBrown" data-id="element-762" data-mp="2671utfbnogfg">{title}</h3>
        </div>
      </div>
      <div className="space-y-4" data-id="element-763" data-mp="1y6cczcet80mq">{children}</div>
    </section>;
}
interface RuleProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  negative?: boolean;
}
function Rule({
  icon,
  children,
  negative
}: RuleProps) {
  return <div className="flex items-start gap-3" data-id="element-764" data-mp="281nuu3lilnyp">
      <div className={`mt-0.5 flex-shrink-0 ${negative ? 'text-coral' : 'text-peach'}`} data-id="element-765" data-mp="234e48kme369a">
        {icon}
      </div>
      <p className="text-warmBrown/80 leading-relaxed" data-id="element-766" data-mp="2h2vq0csqi8ok">{children}</p>
    </div>;
}
interface CalloutProps {
  color: 'peach' | 'sage' | 'lavender' | 'coral';
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
}
function Callout({
  color,
  icon,
  title,
  children
}: CalloutProps) {
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      border: 'border-peach/20',
      text: 'text-peach'
    },
    sage: {
      bg: 'bg-sage/10',
      border: 'border-sage/20',
      text: 'text-sage'
    },
    lavender: {
      bg: 'bg-lavender/10',
      border: 'border-lavender/20',
      text: 'text-lavender'
    },
    coral: {
      bg: 'bg-coral/10',
      border: 'border-coral/20',
      text: 'text-coral'
    }
  };
  const c = colorMap[color];
  return <div className={`${c.bg} ${c.border} border rounded-2xl p-5 mt-6`} data-id="element-767" data-mp="35g5i9lfzaw5y">
      <div className="flex items-center gap-2 mb-2" data-id="element-768" data-mp="3afieuxwnjhlq">
        <span className={c.text} data-id="element-769" data-mp="3ai4nl0va435j">{icon}</span>
        <p className={`font-bold ${c.text}`} data-id="element-770" data-mp="2vqlymdkfyya1">{title}</p>
      </div>
      <p className="text-warmBrown/80 leading-relaxed text-sm" data-id="element-771" data-mp="2vpatoaf9fkhc">{children}</p>
    </div>;
}